import { bool } from "prop-types";
import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import { useEstimateEditorSettings, usePresetFieldNames, ValueCell } from "@tools";

export const ProfitCell = observer((cellProps) => {
  const {
    allowEdition,
    isProposal,
  } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  
  return (
    <ValueCell
      colName={ SummaryColumns.C_PROFIT }
      useDynamicWidth
      isHeader
      style={{ cursor: allowEdition && "grab" }}
      { ...cellProps }
    >
      <span>
        {getFieldName("pt-profit")}
      </span>
    </ValueCell>
  )
})

ProfitCell.propTypes = {
  extendPadding: bool,
}